import React, { useState } from 'react';
import { UrlTrackingView } from './UrlTracking.view';
import {
  DEMO_SESSIONS_BY_DAY,
  DEMO_SESSION_URL_ACTIVITIES,
} from './UrlTracking.demoData';
import { DEMO_MEMBERS_OPTIONS } from '../Timeline/Timeline.demoData';

const DEMO_TIMEZONE = 'America/New_York';

export const UrlTrackingDemoComponent = () => {
  const [selectedMember, setSelectedMember] = useState(DEMO_MEMBERS_OPTIONS[0]);
  const [selectedTimezone, setSelectedTimezone] = useState(DEMO_TIMEZONE);
  const [range, setRange] = useState({
    start: DEMO_SESSIONS_BY_DAY[0]?.dayKey,
    end: DEMO_SESSIONS_BY_DAY[0]?.dayKey,
  });

  const day = DEMO_SESSIONS_BY_DAY[0];

  return (
    <UrlTrackingView
      membersOptions={DEMO_MEMBERS_OPTIONS}
      selectedMember={selectedMember}
      onMemberFilterChange={setSelectedMember}
      membersLoading={false}
      membersError={false}
      membersErrorObj={null}
      refetchMembers={() => {}}
      timezoneOptions={[{ value: DEMO_TIMEZONE, label: DEMO_TIMEZONE }]}
      selectedTimezone={selectedTimezone}
      onTimezoneChange={setSelectedTimezone}
      timezonesLoading={false}
      date={range.start}
      onDateChange={(dateStr) => setRange({ start: dateStr, end: dateStr })}
      onRefresh={() => {}}
      loading={false}
      day={day}
      teamId="demo-team"
      urlActivitiesBySessionId={DEMO_SESSION_URL_ACTIVITIES}
    />
  );
};
